
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SportIcons',
  props: {
    sportId: {
      type: String,
      required: true
    },
    cloudfrontUrl: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: false
    },
    size: {
      type: Number,
      required: false,
      default: 16
    }
  },

  methods: {
    getIconPath(sportId: string) {
      // Controlla se ha icon_id (sport dallo store) o solo icon (sport di fallback/sottomenu)
      if (sportId) {
        return (
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/sports/IllinoisIcons/${sportId}.svg`
        );
      } else {
        // Fallback generico
        return (
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/sports/IllinoisIcons/3467550448.svg`
        ); // tennis
      }
    },
    handleImageError(event: any) {
      // Fallback se l'icona non esiste - usa tennis come default
      event.target.src =
        process.env.VUE_APP_URL_CLOUDFRONT +
        '/svg/sports/IllinoisIcons/3467550448.svg';
    }
  }
});
